import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.splice.js";
import "regenerator-runtime/runtime.js";
import * as echarts from "echarts";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, onMounted, reactive, ref, onUnmounted } from "vue";
import { useStore } from "vuex";
import staticData from "@/assets/data/dataScreen.json";
export default defineComponent({
  name: "Thought",
  components: {},
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var store = useStore();
    var data = ref([{
      name: "一月",
      value: 11
    }]);
    var Data = reactive({
      option: {
        color: ["#3F1AF9", "#F9AF1A", "#FF2746", "#CEFB23", "#01FFFF", "#983EFF", "#6786DD", "#9BD280", "#FFDF8F", "#FF67B9", "#62FF52", "#FF9231"],
        backgroundColor: "#0c1d4e",
        title: {
          show: true,
          text: "思想摸排",
          textStyle: {
            color: "#f2f2f2",
            fontSize: 20
          },
          // x: "30%",
          // y: "45%",
          textAlign: 'center',
          left: "38%",
          top: "47%"
        },
        grid: {
          bottom: 150,
          left: 100,
          right: "10%"
        },
        legend: {
          orient: "vertical",
          left: "76%",
          y: 'center',
          textStyle: {
            color: "#f2f2f2",
            fontSize: 11
          },
          itemHeight: 11,
          icon: "circle",
          data: data
        },
        series: [// 主要展示层的
        {
          radius: ["50%", "60%"],
          center: ["39%", "50%"],
          type: "pie",
          label: {
            normal: {
              show: true,
              minAngle: 30,
              formatter: "{c}",
              textStyle: {
                fontSize: 14,
                color: "#4dbdff"
              }
            }
          },
          labelLine: {
            normal: {
              show: true,
              length: 15,
              length2: 13,
              lineStyle: {
                color: "#4dbdff"
              }
            },
            emphasis: {
              show: true
            }
          },
          name: "思想摸排",
          data: data
        }]
      }
    });
    onMounted(function () {
      if (store.state.system.demonstration) {
        data.value = staticData.thoughtData;
        getMountEcherts();
      } else {
        getList();
      }
    });

    var getList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getThoughtDataScreen();

              case 2:
                _context.next = 4;
                return getMountEcherts();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getList() {
        return _ref.apply(this, arguments);
      };
    }();

    var timer;

    var taskGetThought = function taskGetThought() {
      timer = setInterval(function () {
        getList(); // clearInterval(timer);
        // taskGetThought();
      }, 10000);
    };

    if (!store.state.system.demonstration) {
      taskGetThought();
    }

    onUnmounted(function () {
      clearInterval(timer);
    }); // 思想摸排

    var getThoughtDataScreen = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, month;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getThoughtDataScreen"]();

              case 2:
                res = _context2.sent;

                if (res.code == 0) {
                  //获取当前月份
                  month = new Date().getMonth() + 1;
                  data.value = res.data;
                  data.value.splice(month, 12 - month);
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getThoughtDataScreen() {
        return _ref2.apply(this, arguments);
      };
    }(); //挂载eCharts


    var myChartRef = ref();
    var myChartthought;

    var getMountEcherts = function getMountEcherts() {
      myChartRef.value = document.getElementById("main");

      if (myChartRef.value) {
        myChartthought = echarts.init(myChartRef.value);
        myChartthought.setOption(Data.option);
      }
    };

    var init = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                myChartthought.resize();

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function init() {
        return _ref3.apply(this, arguments);
      };
    }();

    window.addEventListener("resize", function () {
      myChartthought.resize();
    });
    return {
      init: init,
      Data: Data,
      getMountEcherts: getMountEcherts,
      getList: getList,
      getThoughtDataScreen: getThoughtDataScreen,
      myChartthought: myChartthought
    };
  }
});